import {
	Contract as EthersContract,
	ContractInterface,
	PopulatedTransaction,
	providers,
	Signer,
} from "ethers"

class Contract {
	_address: string
	_interface: ContractInterface
	_signerOrProvider: Signer | providers.Provider
	contract: EthersContract

	constructor(
		address: string,
		contractInterface: ContractInterface,
		signerOrProvider: Signer | providers.Provider,
	) {
		this._address = address
		this._interface = contractInterface
		this._signerOrProvider = signerOrProvider

		const contract = new EthersContract(
			address,
			contractInterface,
			signerOrProvider,
		)

		this.contract = contract
	}

	async callFunction<
		Args extends Array<any>,
		ReturnVal = PopulatedTransaction,
	>(methodName: string, ...args: Args): Promise<ReturnVal> {
		return this.contract[methodName](...args)
	}
}

export default Contract
